import { useTranslation } from 'react-i18next'
import Select from 'components/common/Select/Select'

const Activity = ({ onChange, value, activities }) => {
  const { t } = useTranslation()

  return (
    <>
      <Select
        options={activities.map( activity => ({
          label: activity,
          value: activity
        }))}
        onChange={val => onChange(val.value)}
        label={t('mainReporting:form.activity.label')}
        placeholder={t('mainReporting:form.activity.placeholder')}
        value={value}
        styles={{
          control:{
            background: '#FFF'
          }
        }}
      />
    </>
  )
}

export default Activity
